










import { Component, Prop, Vue } from "vue-property-decorator";
import TimeLineItemText from "./../utility/TimeLineItemText.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { IActivityLog } from "@/models/activity-log.entity";
import { detailedDate } from "@/lib/utility/date-helper";
import { activityLogName } from "@/lib/utility/activityLogName";
import { ICompany } from "@/models/company.entity";
import { IPerson } from "@/models/person.entity";
import { fetchReference } from "@/lib/utility/fetch-reference.helper";
import MNoContent from "../utility/mmmint/MNoContent.vue";
import { $t } from "@/lib/utility/t";

@Component({
  components: {
    TimeLineItemText,
    MNoContent
  }
})
export default class ActivityTimeLineItemAssociated extends Vue {
  @Prop({ required: true })
  activityLogEntry!: IActivityLog;

  get icon() {
    return this.activityLogEntry.activity === ActivityTypeEnum.CREATE_ASSOCIATED
      ? "mdi-account-multiple-plus"
      : "mdi-account-multiple-minus";
  }

  referencedEntity: IPerson | ICompany | null = null;
  referencedLoading = false;

  async mounted() {
    try {
      const target = this.activityLogEntry?.target?.length ? this.activityLogEntry.target[0] : null;
      if (!target) {
        this.referencedEntity = null;
        this.referencedLoading = false;
        return;
      }
      this.referencedLoading = true;
      const entityRes = await fetchReference(this.activityLogEntry.partnerId, target);
      const entity: IPerson | ICompany | null = (entityRes as IPerson | ICompany | null) || null;
      this.referencedEntity = entity;
    } catch (e) {
      this.$log.error(e);
      this.referencedEntity = null;
    } finally {
      this.referencedLoading = false;
    }
  }

  get activityPath() {
    const activityLogEntry = this.activityLogEntry;
    const isCreate = activityLogEntry.activity === ActivityTypeEnum.CREATE_ASSOCIATED;
    const isPerson =
      activityLogEntry.target &&
      activityLogEntry.target[0] &&
      activityLogEntry.target[0].refType === ResourceEnum.PERSON;

    const suffix = isCreate
      ? isPerson
        ? "addedPersonAssociated"
        : "addedCompanyAssociated"
      : isPerson
      ? "removedPersonAssociated"
      : "removedCompanyAssociated";

    return `timeLine.ActivityTimeLineItemAssociated.${suffix}`;
  }

  get activityText(): string {
    const actorText = activityLogName(this.activityLogEntry);
    const dateText = detailedDate(this.activityLogEntry.timestamp.created);
    const targetText = this.associatedName;
    const raw = $t(this.activityPath, { actor: actorText, date: dateText, target: targetText });
    return String(raw);
  }

  get associatedName(): string {
    if ((this.referencedEntity as ICompany).companyName) {
      return (this.referencedEntity as ICompany).companyName;
    } else {
      return `${this.referencedEntity?.firstName || ""} ${this.referencedEntity?.lastName || ""}`.trim();
    }
  }
}
